import React, { Component } from 'react';
import { connect } from 'react-redux';
import Menu from 'Menu';
import Footer from './Footer';
import LoadingBar, { showLoading, hideLoading } from 'react-redux-loading-bar';
import { NotificationContainer } from 'react-notifications';
import { HORIZONTAL } from 'constants';
import SubMenu from './menu/SubMenu';
import {browserHistory} from "react-router";
import {SelectCommunity} from "./SelectCommunity/SelectCommunity";


@connect((store) => {
  return {
    auth: store.auth,
    fetched: store.auth.fetched,
    currentNavPage: store.params.currentNavPage,
    subMenuDirection: store.params.subMenuDirection,
    redirectUrl: store.auth.redirectUrl,
    orderLines: store.orderLines,
  };
})
export default class Layout extends Component {

  componentWillUpdate(nextProps, nextState) {
    const { location, dispatch } = nextProps;
    if (location.action == 'PUSH') {
      dispatch(showLoading());
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { location, dispatch } = this.props;
    if (location.action == 'PUSH') {
      dispatch(hideLoading());
    }
    if(prevProps.redirectUrl != this.props.redirectUrl || prevProps.fetched != this.props.fetched )
    {
      if(this.props.fetched && this.props.redirectUrl!= null)
        browserHistory.push(this.props.redirectUrl);
    }
  }

  render() {
    const { subMenuDirection, currentNavPage, auth: { fetching, currentClient, user }, step  } = this.props;

    //pour fixer probléme de la page de paiement
    // if(user && !currentClient) {
    //   return <SelectCommunity />;
    // }

    return (
      <div style={{minHeight : "100vh"}} id="offCanvas-wrapper" className="off-canvas-wrapper">
        <div>
          <LoadingBar className="loading-bar" />
          {currentNavPage !== "STATISTICS-IFRAME" && this.props.orderLines.embedded == 0 && currentNavPage!= "NOT_FOUND_PAGE" && currentNavPage!= "PAYMENT_REFUSED" && currentNavPage!= "REFUND_PAGE" ? <Menu /> : null }
          <NotificationContainer />
          <div>
            {currentNavPage !== "STATISTICS-IFRAME" && this.props.orderLines.embedded == 0 && currentNavPage!= "NOT_FOUND_PAGE" && currentNavPage!= "PAYMENT_REFUSED" && currentNavPage!= "REFUND_PAGE" ? <SubMenu /> : null}
            <div>
              {this.props.children}
              {(["HOME"].indexOf(currentNavPage) != -1) ? <Footer /> : null}
            </div>
          </div>
        </div>
        <div className="mask hide"></div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./app/components/Layout.js